{
  "availability": {
    "enabled": {
      "entitlement": "fb::actions::extended",
      "featureFlag": "fb_add_to_flow_action",
      "flowTypes": ["AUTOMATION", "CAMPAIGN"]
    },
    "hidden": {
      "transactional": true,
      "triggerEvents": [
        "",
        "ProductAddedToCart",
        "RechargeCheckoutStarted",
        "ShopifyCheckoutStarted",
        "SubscriberViewedProduct"
      ]
    }
  },
  "badge": null,
  "category": "Postscript",
  "description": "Add subscribers to an Automation Flow once they reach this step.",
  "featureFlag": "fb_add_to_flow_action",
  "fields": [
    {
      "type": "FlowSelection",
      "options": {
        "paramName": "flowId",
        "label": "Automation Flow",
        "message": "An automation must use the \"Added from Another Flow\" trigger to show up in this list."
      }
    },
    {
      "type": "Checkbox",
      "options": {
        "paramName": "removeSubscriber",
        "iconName": "UserMinus",
        "label": "Remove subscribers from current flow once they are added to the new Automation Flow",
        "shortLabel": "Remove from current flow"
      }
    }
  ],
  "helpText": "Add subscribers to another Automation Flow.",
  "iconName": "UserPlus",
  "label": "Add to Flow",
  "type": "AddToFlow"
}
